import { render, staticRenderFns } from "./securitySetting.vue?vue&type=template&id=2432ce19&"
import script from "./securitySetting.vue?vue&type=script&lang=js&"
export * from "./securitySetting.vue?vue&type=script&lang=js&"
import style0 from "./securitySetting.vue?vue&type=style&index=0&id=2432ce19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports